import type { CCQ_DBIdType } from "../permissions/idUtils";

export enum CustomClaimsTypesEnum {
    ServerClaim = "ServerClaim",
    UXClaim = "UXClaim",
    TableClaim = "TableClaim",
}

export enum PermissionTypesOnDataEnum {
    None = "None",
    Read = "Read",
    Update = "Update",
    Delete = "Delete",
    All = "All",
}

export interface TupleOfCustomClaimsTypesEnumAndListOfDictionaryOfStringAndInteger {
    item1: CustomClaimsTypesEnum;
    item2: { [key: string]: number; }[] | null;
}

export interface EntityWithPermissionsDTO {
    usersWithPermission: UserPermissionTypeDTO[];
    userGroupsWithPermission: UserPermissionTypeDTO[];
    rowId: CCQ_DBIdType;
    rowDisplayName: string | null;
}

export interface UserPermissionTypeDTO {
    id: CCQ_DBIdType;
    permissions: PermissionTypesOnDataEnum;
}

export interface BaseDataMultiOwner {
    id: CCQ_DBIdType;
    recordId: string;
    appUserOrAppUserGroupId: string;
    permTypes: PermissionTypesOnDataEnum;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimGroupAddUpdateDeleteDTO {
    claimGroupSets: CCQ_DBIdType[];
    claimGroupsToAddUpdate: ClaimGroup[];
    claimGroupsToRemove: CCQ_DBIdType[];
    removeExistingUnMentionedClaimGroups: boolean;
}

export interface ClaimEnumsToAddUpdateDeleteDTO {
    claimSets: CCQ_DBIdType[];
    claimBaseToAddUpdate: ClaimBaseDTO[];
    claimEnumsToRemoveValue: number[];
    removeExistingUnMentionedClaimBase: boolean;
}

export interface ClaimBaseDTO {
    claimType: CustomClaimsTypesEnum;
    claimValue: number;
    priorityOfPermission: number;
    allow: boolean;
}

export interface ApplicationUsersToApplicationUserGroupsDTO {
    applicationUsersGroups: CCQ_DBIdType[];
    applicationUsersToAdd: CCQ_DBIdType[];
    applicationUsersToRemove: CCQ_DBIdType[];
    removeExistingUnMentioned: boolean;
}

export interface ClaimGroupsInApplicationUser extends ClaimGroupBaseOfApplicationUser {
}

export interface ClaimEnumsInClaimGroup extends ClaimBaseGenericOfClaimGroup {
}


export interface ClaimBaseGenericOfClaimGroup extends ClaimBase {
    record: ClaimGroup | null;
}

export interface ClaimGroupsInClaimGroup extends ClaimGroupBaseOfClaimGroup {
}

export interface ClaimGroupsInApplicationUserGroup extends ClaimGroupBaseOfApplicationUserGroup {
}

export interface ClaimEnumsInApplicationUserGroup extends ClaimBaseGenericOfApplicationUserGroup {
}

export interface ClaimBaseGenericOfApplicationUserGroup extends ClaimBase {
    record: ApplicationUserGroup | null;
}

export interface ClaimEnumsInApplicationUser extends ClaimBaseGenericOfApplicationUser {
}

export interface ClaimBaseGenericOfApplicationUser extends ClaimBase {
    record: ApplicationUser | null;
}

export interface ClaimGroupBaseOfClaimGroup {
    id: CCQ_DBIdType;
    claimGroup: ClaimGroup;
    claimGroupId: CCQ_DBIdType;
    record: ClaimGroup | null;
    recordId: string;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimGroupBaseOfApplicationUser {
    id: CCQ_DBIdType;
    claimGroup: ClaimGroup;
    claimGroupId: CCQ_DBIdType;
    record: ApplicationUser | null;
    recordId: CCQ_DBIdType;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimGroupBaseOfApplicationUserGroup {
    id: string;
    claimGroup: ClaimGroup;
    claimGroupId: string;
    record: ApplicationUserGroup | null;
    recordId: string;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimGroup {
    id: CCQ_DBIdType;
    name: string;
    builtInGroup: boolean;
    claimEnumsInClaimGroups: ClaimEnumsInClaimGroup[] | null;
    claimGroupsInApplicationUserGroups: ClaimGroupsInApplicationUserGroup[] | null;
    claimGroupsInApplicationUsers: ClaimGroupsInApplicationUser[] | null;
    claimGroupsInClaimGroups: ClaimGroupsInClaimGroup[] | null;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}


export interface ApplicationUser {
    id: CCQ_DBIdType;
    oidcId: string;
    name: string;
    userName: string;
    email: string | null;
    applicationUserApplicationUserGroups: ApplicationUserApplicationUserGroup[] | null;
    claimEnumsInApplicationUsers: ClaimEnumsInApplicationUser[] | null;
    claimGroupsInApplicationUsers: ClaimGroupsInApplicationUser[] | null;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ApplicationUserGroup {
    id: CCQ_DBIdType;
    name: string | null;
    isDeleted: boolean;
    applicationUserApplicationUserGroups: ApplicationUserApplicationUserGroup[] | null;
    claimEnumsInApplicationUserGroups: ClaimEnumsInApplicationUserGroup[] | null;
    claimGroupsInApplicationUserGroups: ClaimGroupsInApplicationUserGroup[] | null;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ApplicationUserApplicationUserGroup {
    id: CCQ_DBIdType;
    name: string | null;
    isDeleted: boolean;
    applicationUser: ApplicationUser | null;
    applicationUserId: string;
    applicationUserGroup: ApplicationUserGroup | null;
    applicationUserGroupId: string;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}

export interface ClaimBase {
    id: CCQ_DBIdType;
    claimType: CustomClaimsTypesEnum;
    claimValue: number;
    priorityOfPermission: number;
    allow: boolean;
    recordId: string;
    isDeleted: boolean;
    lastUpdatedDateTime: Date | null;
    createdDateTime: Date | null;
}
export interface TupleOfStringAndListOfBaseDataMultiOwner {
    item1: string | null;
    item2: BaseDataMultiOwner[] | null;
}

export interface DataRecordAddUpdateDeletePermissionTableSubListDTO {
    tableName: string;
    recordIdsInSetToApplyPermissionsTo: string[];
    recordIdsInSetToRemovePermissionsFrom: string[];
}